import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const itamRoute: InvariantJiraRoute = {
	name: 'itam',
	path: '/jira/itam/:practice',
	exact: true,
};
